import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const applicantPreviewWrapper = () => css`
  width: 10rem;
`;

export const applicantPopoverWrapper: ThemedFunctor = ({ theme }) => css`
  min-width: 18rem;
  padding: ${theme.remSize[25]};
`;

export const provincesPopoverWrapper: ThemedFunctor = ({ theme }) => css`
  min-width: 6rem;
  padding: ${theme.remSize[150]};
`;

export const managersPreviewWrapper: ThemedFunctor = ({ theme }) => css`
  display: flex;
  align-items: center;

  > div:first-child {
    position: relative;
    z-index: 2;
  }

  > div:not(:first-child) {
    position: relative;
    z-index: 1;
    margin-left: -${theme.remSize[100]};
  }
`;

export const managersPopoverWrapper: ThemedFunctor = ({ theme }) => css`
  min-width: 12rem;
  padding: ${theme.remSize[150]};
`;

export const missedCallRegistryPopoverWrapper: ThemedFunctor = ({ theme }) => css`
  min-width: 18rem;
  padding: ${theme.remSize[150]};
`;
